module.exports = __webpack_public_path__ + "static/media/DiveMaster.13e09269.jpg";